import { v5 as uuid } from 'uuid'

const browserNamespace = '1bf9c280-368b-4368-aa0d-15db74899ab9'
const browserKey = uuid('browserId', browserNamespace)
const emailKey = uuid('email', browserNamespace)

export const getBrowserId = () => {
    if (!localStorage.getItem(browserKey)) {
        setBrowserId()
    }

    return localStorage.getItem(browserKey)
}

export const setBrowserId = () => {
    const browserId = generateBrowserFingerPrint()
    localStorage.setItem(browserKey, browserId)
}

export const removeBrowserId = () => {
    localStorage.removeItem(browserKey)
}

export const refreshBrowserId = () => {
    removeBrowserId()
    setBrowserId()
    return getBrowserId()
}

export const getQRCodeEmail = () => {
    return localStorage.getItem(emailKey)
}

export const setQRCodeEmail = (value: string) => {
    localStorage.setItem(emailKey, value)
}

export const removeQRCodeEmail = () => {
    localStorage.removeItem(emailKey)
}

/**
 * Generate a cryptographically-random, unguessable browser token.
 *
 * This value is rendered as the QR code and acts as a single-use capability
 * secret for the QR sign-in handshake, so it MUST be unpredictable. The previous
 * implementation derived it from `Date.now()` via uuid v5 (a deterministic hash),
 * which is enumerable given the fixed namespace + an approximate timestamp.
 * `crypto.randomUUID()` gives 122 bits of entropy from the platform CSPRNG.
 */
export const generateBrowserFingerPrint = () => {
    return crypto.randomUUID()
}
